import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ListPeriodeResponse, PeriodeData } from 'src/app/class/datatype';
import { environment } from 'src/environments/environment';
import { CashierPaymentRequest, CashierStudent } from './cashier.models';

/**
 * Akses API layar kasir (clientapi/cashpay/*, login All In One, permission cashpay.use).
 * Aturan dan pesan respons sama dengan checkin/* di Cashpay lama.
 */
@Injectable({ providedIn: 'root' })
export class CashierService {
  private readonly base = environment.apiUrl + 'clientapi/cashpay/';

  constructor(private http: HttpClient) {}

  listPeriode(): Observable<ListPeriodeResponse> {
    const params = new HttpParams().set('status', 'ACT').set('per_page', '1000');

    return this.http.get<ListPeriodeResponse>(this.base + 'periode', { params });
  }

  getStudent(regcode: string, periode: PeriodeData): Observable<CashierStudent> {
    const params = new HttpParams()
      .set('regcode', regcode)
      .set('periode_date', String(periode.date))
      .set('periode_month', String(periode.month))
      .set('periode_year', String(periode.year ?? new Date().getFullYear()));

    return this.http.get<CashierStudent>(this.base + 'student', { params });
  }

  pay(request: CashierPaymentRequest): Observable<CashierStudent> {
    return this.http.post<CashierStudent>(this.base + 'payment', request);
  }
}
